module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_13.5e492cfe.png";